<template>
  <div class="Thumbnail">
    <div v-if="file !== null">
      <b-aspect
        v-if="url"
        aspect="16:9"
      >
        <img :src="url">
      </b-aspect>
      <b-aspect
        v-else
        aspect="16:9"
      >
        <img src="data:image/gif;base64,R0lGODdhpwBTAJEAALS0tLS0tO7u7gAAACwAAAAApwBTAAACt4SPqcvtD6OctNqLs968+w+G4kiW5omm6sq27gvH8kzX9o3n+s73/g8MCofEovGITCqXzKbzCY1Kp9Sq9YrNarfcrvcLDovH5LL5jE6r1+y2+w2Py+emgP2eCSjudrpB74cDGGgzSEhjeJB4mLJ44ugYZxg5Qcn4MJlgObKp1tnxSRh6ScKXOFoBiUrK2ur6ChsrO0tba3uLm6u7y9vr+wscLDxMXGx8jJysvMzc7PwMHS09TR1SAAA7">
      </b-aspect>

      <div
        v-if="! url"
        class="btns"
      >
        {{ feedbackMsg }}
        <!-- <button
          v-if="allowManualRetry"
          class="text-button"
          @click.prevent="retry"
        >
          <b-icon icon="arrow-clockwise" /><span class="text-button__label">Opnieuw proberen</span>
        </button> -->
      </div>
      <div
        v-else
        class="btns"
      >
        <button
          v-if="! disabled"
          class="text-button"
          @click.prevent="handleDisconnectFile"
        >
          <b-icon icon="x" /><span class="text-button__label">Wissen</span>
        </button>
        <button
          class="text-button"
          @click.prevent="handleDownload"
        >
          <b-icon icon="download" /><span class="text-button__label">{{
            linklabel || file.getFullFilename()
          }}</span>
        </button>
      </div>
    </div>

    <div v-else>
      <b-aspect aspect="16:9">
        <img src="data:image/gif;base64,R0lGODdhpwBTAJEAALS0tLS0tO7u7gAAACwAAAAApwBTAAACt4SPqcvtD6OctNqLs968+w+G4kiW5omm6sq27gvH8kzX9o3n+s73/g8MCofEovGITCqXzKbzCY1Kp9Sq9YrNarfcrvcLDovH5LL5jE6r1+y2+w2Py+emgP2eCSjudrpB74cDGGgzSEhjeJB4mLJ44ugYZxg5Qcn4MJlgObKp1tnxSRh6ScKXOFoBiUrK2ur6ChsrO0tba3uLm6u7y9vr+wscLDxMXGx8jJysvMzc7PwMHS09TR1SAAA7">
      </b-aspect>
      Een moment geduld a.u.b.
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { saveAs } from 'file-saver'

export default {
  name: 'FileThumnail',
  props: {
    uuid: {
      type: String,
      required: true,
    },
    wide: {
      type: Boolean,
      default: true,
    },
    linklabel: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    filenameprefix: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      url: null,
      busy: false,
      feedbackMsg: 'Niet beschikbaar',
      manualRetries: 0,
      maxManualRetries: 5,
    }
  },
  computed: {
    ...mapGetters('files', [
      'isFileAvailable',
      'getFileByUuid',
      'getFileFailedToLoad',
    ]),
    file() {
      if (! this.isFileAvailable({
        uuid: this.uuid,
      })) {
        return null
      }

      return this.getFileByUuid({
        uuid: this.uuid,
      })
    },
    allowManualRetry() {
      return this.manualRetries <= this.maxManualRetries
    },
  },
  watch: {
    /**
     * TODO: CBAPI - We're ignoring whether the actual file is available
     *  The callback to the DB takes longer to process than getting the file data
     *  after when uploading a new file. This means we get a 'false' flag for
     *  files that you've just uploaded. This would be sorted out with Websockets,
     *  which we do not yet have at this time.
     */
    file: {
      immediate: true,
      handler: async function() {
        await this.handleGetUrl()
      },
    },
  },
  async created() {
    if (! this.isFileAvailable({ uuid: this.uuid })) {
      await this.loadFileInformationByUuid({
        uuid: this.uuid,
      })
    }
  },
  methods: {
    ...mapActions('files', [
      'loadFileInformationByUuid',
      'getFileLinkByUuid',
    ]),

    handleDisconnectFile: async function() {
      this.$emit('disconnect', { uuid: this.uuid })
    },

    handleGetUrl: async function() {
      // We have file info, but no url
      // and we're not already getting the url
      if (
        this.file !== null &&
        ! this.url &&
        this.busy === false
      ) {
        this.busy = true


        // if (
        //   this.isFileAvailable

        // ) {
        //   console.log("file information is available ... ")
        // }

        if (! this.isFileAvailable({ uuid: this.uuid }) ) {
          this.url = false
          this.feedbackMsg = 'Niet beschikbaar'
        } else {

          // if file is not uploaded -> avoid upload
          if (this.file.status.uploaded === false) {
            this.url = false

            const now = Math.floor(Date.now())

            // Allow retries for max 5 seconds after the latest File information update
            if ((now - this.file.ts) < 5000) {
              this.feedbackMsg = 'Nog niet beschikbaar'

              // After 500, retry the download
              setTimeout(this.retry, 500)

            } else {
              // Note: this code is reached about 5 seconds after uploading a file, and 10 failed attempts to download it
              this.feedbackMsg = 'Het opslaan van het bestand is mislukt'
            }

          } else {
            this.url = await this.getFileLinkByUuid({
              uuid: this.uuid,
            })
          }
        }

        this.busy = false
      }
    },

    retry: async function() {
      await this.loadFileInformationByUuid({ uuid: this.uuid, force: true })
    },

    /**
     * The uuid based file download
     */
    handleDownload: async function() {
      try {
        const uuid = this.uuid
        const file = this.file

        if (! file) return

        // Get a fresh url, because the one stored in data
        // may already be expired
        // TODO: Make this smarter
        const url = await this.getFileLinkByUuid({ uuid })

        if (! url) {
          throw new Error('missing url')
        }

        // Generate the filename
        const filenameprefix = this.filenameprefix ? `${this.filenameprefix}-` : ''
        const filename = `${filenameprefix}${file.filename}.${file.extension}`

        // Chrome, FF, Edge
        if (window.browser && window.browser.downloads) {
          window.browser.downloads.download({ url, filename })
        } else { // Safari, etc.
          const res = await fetch(url)
          const blob = await res.blob()
          saveAs(blob, filename)
        }
      } catch (e) {
        // console.log(e)
        this.$bvModal.show('file-error')
      }
    },
  },
}
</script>

<style lang="scss">
.FileThumbnail {
  list-style: none;
  margin: 0;
  padding: 10px;
  background: $neutral-grey1;
  position: relative;
  display: inline-block;
  width: calc(50% - 5px);
  margin-bottom: 1rem;

  &:nth-child(2n + 2) {
    margin-left: 10px;
  }

  &.FileThumbnails--wide {
    width: 100%;
    margin-left: 0;

    .btns {
      display: flex;
      justify-content: space-between;

      button {
        display: inline-block;
      }
    }
  }


  .b-aspect-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img {
    display: inline-block;
    margin: auto;
    max-width: 100%;
    max-height: 100%;
  }


  .text-button {
    display: flex;
    align-items: center;
    font-family: inherit;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: $primary-darkblue;
    fill: $primary-darkblue;
    background-color: transparent;
    border: 0;
    border-radius: 0;
    cursor: pointer;

    .text-button__label {
      @include breakpoint('s') {
        display: none;
      }
    }

    &:hover {
      color: $primary-red;
      fill: $primary-red;
    }

    &:focus,
    &:active {
      outline: 2px solid $primary-black;
    }

    .b-icon {
      margin-right: 0.3em;
    }
  }
  .b-icon {
    width: 14px;
  }
}
</style>
